// theme.js
import { extendTheme } from "@chakra-ui/react";
import { mode } from "@chakra-ui/theme-tools";

const theme = extendTheme({
  config: {
    initialColorMode: "dark",
    useSystemColorMode: true,
  },
  fonts: {
    heading: "DM sans, sans-serif",
    body: "DM sans, sans-serif",
  },
  colors: {
    brand: {
      50: "#F7FAFC",
      100: "#EDF2F7",
      200: "#E2E8F0",
      300: "#CBD5E0",
      400: "#A0AEC0",
      500: "#718096",
      600: "#4A5568",
      700: "#2D3748",
      800: "#1A202C",
      900: "#171923",
    },
  },
  styles: {
    global: (props) => ({
      "html, body, #__next": {
        width: "100%",
        minHeight: "100vh",
        margin: 0,
        padding: 0,
      },
      body: {
        fontFamily: "body",
        color: mode("brand.800", "brand.50")(props),
        backgroundImage: mode(
          "linear-gradient(145deg, #E2E8F0, #F7FAFC)",
          "linear-gradient(145deg, #1A202C, #2D3748)"
        )(props),
        lineHeight: "base",
      }
    }),
  },
});

export default theme;